import React from "react";
import styled from "styled-components";

const StyledParagraph = styled.p`
  font-size: 14px;
`;

function createArrayWithLength(spaces) {
  return Array(spaces).fill(0);
}

export const LineBreaker = ({spaces = 0}) => 
  createArrayWithLength(spaces).map((_, index) => <br key={`break-${index}`} />);

// spacing bottom due to how spacing works need an extra <br />
const getSpacesBottom = spacesBottom => spacesBottom === 0 ? 0 : spacesBottom + 1;

export const VerifyParagraph = ({children, spacesTop = 0, spacesBottom = 0}) => (
  <StyledParagraph>
    <LineBreaker spaces={spacesTop} />
    {children}
    <LineBreaker spaces={getSpacesBottom(spacesBottom)} />
  </StyledParagraph>
);